import { render, staticRenderFns } from "./ModalPopup.vue?vue&type=template&id=03467de5&"
import script from "./ModalPopup.vue?vue&type=script&lang=js&"
export * from "./ModalPopup.vue?vue&type=script&lang=js&"
import style0 from "./ModalPopup.vue?vue&type=style&index=0&id=03467de5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports